
import { TooltipFieldComponent } from "./../tooltip-field/tooltip-field.component";
import { Component, OnInit, OnDestroy, ViewChild, Inject, ElementRef } from "@angular/core";
import { NgbModal, NgbModalRef, NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { CreatePlanComponent } from "../../../components/create-plan/create-plan.component";
import { EspNoRowsOverlayComponent } from "../../../components/no-rows-overlay/no-rows-overlay.component";
import { Router, ActivatedRoute } from "@angular/router";
import { MessageService } from "primeng/api";
import { Observable, Subscription } from "rxjs";
import { DatePipe, DOCUMENT } from "@angular/common";
import {GridApi, IDatasource, IGetRowsParams, IRowNode, SortModelItem} from "ag-grid-community";
import { Store, select } from "@ngrx/store";
import { Actions, ofType } from "@ngrx/effects";
import { GetPlanList, PlanListReceived, AppActionTypes, DeletePlans, DeletePlansSuccess, DeletePlansFailed, PlanListRetrieveFailed } from "src/app/store/actions";
import { DateRangeFieldComponent } from "../date-range-field/date-range-field.component";
import { TranslateService } from "@ngx-translate/core";
import { ModifiedDateFieldComponent } from "../modified-date-field/modified-date-field.component";
import { PlanLoadingOverlayComponent } from "../plan-loading-overlay/plan-loading-overlay.component";
import { EntityFieldComponent } from "../entity-field/entity-field.component";
import { InputTextComponent } from "src/app/components/input-text/input-text.component";
import { EntityTypeFieldComponent } from "../entity-type-field/entity-type-field.component";
import { Plan, Features } from "src/app/models/plan";
import { WfmModalComponent as modalComponent} from "src/app/components/wfm-modal/wfm-modal.component";
import { AuthenticationService } from "src/app/authentication.service";
import { DialogOptions } from "src/app/common/dialog-options";
import { CreatePlanComponentV2 } from "src/app/components/create-plan-v2/create-plan-v2.component";
import { PlanGen } from "../common/plan-param";
import { EspTableHeaderComponent } from "src/app/components/esp-table-header/esp-table-header.component";
import { GridItemActionComponent } from "src/app/components/grid-item-action/grid-item-action.component";
import { tabSuppressKeyboardEventForFocusableChildren } from "src/app/common/utils/ag-grid-a11y";
import { suppressHomeEndKeyboardEvent } from "src/app/common/utils/ag-grid-a11y";
import { suppressGridTabToInteractiveControls } from "src/app/common/utils/ag-grid-a11y";
import { combineGridKeyboardSuppressors } from "src/app/common/utils/ag-grid-a11y";
import { fixGridNonActiveTabOrder } from "src/app/common/utils/ag-grid-a11y";
import { makeGridScrollRegionFocusable } from "src/app/common/utils/ag-grid-a11y";
import { setFlatGridRole } from "src/app/common/utils/ag-grid-a11y";
import { setGridActivationDescription } from "src/app/common/utils/ag-grid-a11y";
import { setGridAccessibleName } from "src/app/common/utils/ag-grid-a11y";
import { GRID_ARIA_LOCALE_TEXT } from "src/app/common/utils/ag-grid-a11y";
import { environment } from "src/environments/environment";
import {MswfRulesDialogComponent} from '../mswf-rules-dialog/mswf-rules-dialog.component';
import {CreatePlanCXoneComponent} from '../create-plan-cxone/create-plan-cxone.component';
import {TenantService} from '../../../tenant.service';

@Component({
  standalone: false,
  selector: "wfm-esp-plan-list-page",
  templateUrl: "./plan-list-page.component.html",
  styleUrls: ["./plan-list-page.component.scss"],
  providers: [MessageService]
})
export class PlanListPageComponent implements OnInit, OnDestroy {


  public gridApi: GridApi = null;
  public gridColumnApi: any;
  private scrollRegionSyncCleanup: (() => void) | null = null;

  protected subscriptionList: Array<Subscription> = [];

  /* Grid Properties */
  public rowClassRules;
  public rowBuffer = 10;
  public rowSelection = "multiple";
  public rowModelType = "infinite";
  public paginationPageSize = 50;
  public cacheOverflowSize = 1;
  public maxConcurrentDatasourceRequests = 1;
  public infiniteInitialRowCount = 0;
  public maxBlocksInCache = 1;

  public loadingOverlayComponent = "planLoadingOverlay";
  public noPlanOverlayComponent = "noPlanOverlay";
  public noPlanOverlayComponentParams = {
    getOverlayMsg: () => {
      let msgKey = this.filterText ? "search.no.results.msg" : "manage.plan.no.plans";
      return this.translate.instant(msgKey)
    }
  }

  public frameworkComponents: any;
  public context;
  public readonly gridAriaLocaleText = GRID_ARIA_LOCALE_TEXT;

  public currentGetRowParam: IGetRowsParams;
  public datasource: IDatasource;
  public rowData = [];

  public filterText: string;
  public searchAnnouncement = "";
  private searchJustCleared = false;
  private checkboxAriaLabelsScheduled = false;
  public planCreateSuccess = false; //flag

  public espPermission:EspPermission = EspPermission.VIEW;
  public locale : string = environment.defaultLocale;
  protected isRowSelectable:any;
  private sortBy: any;
  private sortOrder: any;
  public  _isLoading = false;

  private readonly DEFAULT_SORT_MODEL:SortModelItem[] = [{ colId: "planName", sort: "asc" }];

  @ViewChild("searchTextBox") searchBoxEl: InputTextComponent;
  @ViewChild("planDeletePopover") planDeletePopover: NgbPopover;

  constructor(private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private store: Store<any>,
    private action$: Actions,
    private translate: TranslateService,
    private authService: AuthenticationService,
    public tenantService: TenantService,
    private elementRef: ElementRef,
    @Inject(DOCUMENT) private document: Document) {

    this.context = {
      componentParent: this,
      isLoading: this.isLoading.bind(this),
      showMswfRulesDlg:this.showMswfRulesDlg.bind(this)
    };
    this.rowClassRules = {
      "row-disabled": (params) => this.disableRows(params),
      "row-view-only": (params) => this.isRowViewOnly(params)
    };
    this.isRowSelectable = function (rowNode) {
      return (rowNode.data && rowNode.data.permission === EspPermission.VIEW) ? false : true;
    };

  }

  ngOnInit() {
    this.frameworkComponents = {
      GridItemActionComponent: GridItemActionComponent,
      TooltipField: TooltipFieldComponent,
      DateRangeField: DateRangeFieldComponent,
      ModifiedDateField: ModifiedDateFieldComponent,
      EntityField: EntityFieldComponent,
      EntityTypeField: EntityTypeFieldComponent,
      noPlanOverlay: EspNoRowsOverlayComponent,
      planLoadingOverlay: PlanLoadingOverlayComponent,
      agColumnHeader: EspTableHeaderComponent
    };
    let state = this.store.select("state");
    state.subscribe((data) => {
      if (data.user){
        this.espPermission = data.user.espPermission;
      }
      if (data.locale) {
        this.locale = data.locale;
      }
    });
    this.addToSubscriptionList(this.activatedRoute.queryParams
      .subscribe(params => {
        this.sortBy = params['sortBy'] || null;
        this.sortOrder = params['sortOrder'] || null;
        this.setColumnDefsSort(this.sortBy, this.sortOrder);
      }));
    this.columnDefs.forEach(a => a.headerComponentParams =  {
      headerPrefix: "plan.header.",
      // Keep column-name tooltips available on mouse hover, but do not open
      // them merely because keyboard focus moved onto a Manage Plans header.
      showTooltipOnFocus: false,
      // Select remains skipped, while the visible Actions columnheader is a
      // named stop between Forecast Name and the first row control.
      includeInHeaderTabOrder: a.colId === "actions",
      focusFirstBodyControl: () => this.focusFirstGridBodyControl()
    });
    //    this.filterRows("MSWF CT SET")
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.api;
    this.datasource = {rowCount: null, getRows: (params: IGetRowsParams) => this.getPlanList.call(this, params) };
    this.gridApi.setDatasource(this.datasource);
    this.initHandlers();
    this.setColumnVisibility();
    this.gridApi.sizeColumnsToFit();
    // a11y (ESP-19079): flat plan list is a data table, not a hierarchy — use
    // role="grid" so the rowgroup/scroll-region children are in a valid
    // context (treegrid disallows the promoted group scroll region).
    setFlatGridRole(this.elementRef.nativeElement);
    fixGridNonActiveTabOrder(this.elementRef.nativeElement);
    // Retain and dispose the cleanup so the header/body scroll listeners can't
    // accumulate if onGridReady fires again for the same grid.
    this.scrollRegionSyncCleanup?.();
    this.scrollRegionSyncCleanup = makeGridScrollRegionFocusable(this.elementRef.nativeElement);
    // a11y (ESP-18522): announce the row-level open action once on grid entry.
    setGridActivationDescription(this.elementRef.nativeElement, "planGridActivationHelp");
    // a11y (ESP-18464): give the grid a caption so JAWS announces "Manage
    // Plans" on grid entry and on "T" table navigation.
    setGridAccessibleName(this.elementRef.nativeElement, this.translate.instant("plan.page.title"));
  }

  public isLoading():boolean{
    return this._isLoading;
  }

  setColumnVisibility(){
    if (!this.hasEspModifyPermission) {
      this.gridColumnApi.setColumnVisible("multiSelect", false);
      this.gridColumnApi.setColumnVisible("actions", false);
    }

    if (this.tenantService.isCXOne) {
      this.gridColumnApi.setColumnVisible("entityType", false);
      this.gridColumnApi.setColumnVisible("entity", false);
      this.adjustColumnWidths();
    }
  }

  getPlanList(params: IGetRowsParams) {
    this.currentGetRowParam = params;
    this.startLoadingGrid();
    // console.log("Getting datasource rows, start: " + params.startRow + ", end: " + params.endRow);
    let blockSize = params.endRow - params.startRow;
    let columnId = "PLAN_NAME";
    let sortOrder = "ASC";
    if (params.sortModel.length > 0) {
      sortOrder = params.sortModel[0].sort.toUpperCase();
      columnId = ColumnId[params.sortModel[0].colId];
    }
    let payload = { offset: params.startRow, limit: blockSize, "sort-by": columnId, "sort-order": sortOrder, "plan-name-filter": this.filterText };
    this.store.dispatch(new GetPlanList(payload));
  }

  filterRows(text) {
      this.filterText = text;
      // Clear any prior announcement immediately when filter is cleared; for
      // non-empty text the receive handler will set the new announcement.
      if (!text) {
        this.searchAnnouncement = "";
        this.searchJustCleared = true;
      }
      this.currentGetRowParam.startRow = 0;
      let sortModel = this.currentGetRowParam.sortModel;
      if(sortModel.length == 0)
      sortModel = this.DEFAULT_SORT_MODEL;
      this.gridColumnApi.applyColumnState({state:sortModel});
      this.gridApi.ensureIndexVisible(0, "top");
      this.gridApi.setDatasource(this.datasource);

  }

  /**
   * Update the screen-reader announcement for the current filterText using the
   * backend total row count (the infinite row model does not know the real total
   * until the server responds). Empty string when no active search; "No results
   * found" or "{{count}} results found" otherwise. Read by JAWS via the polite
   * aria-live region inside <input-text>.
   */
  private updateSearchAnnouncement(totalCount: number) {
    if (!this.filterText) {
      if (this.searchJustCleared) {
        this.searchAnnouncement = totalCount > 0
          ? this.translate.instant("search.all.results.count", { count: totalCount })
          : "";
        this.searchJustCleared = false;
      } else {
        this.searchAnnouncement = "";
      }
      return;
    }
    this.searchAnnouncement = totalCount === 0
      ? this.translate.instant("search.no.results.msg")
      : this.translate.instant("search.results.count", { count: totalCount });
  }

  deleteSelectedPlans() {
    // ESP-21682: close the confirmation popover after confirming. When Confirm
    // is activated via keyboard (Tab + Enter) there is no outside click to
    // trigger ngbPopover's autoClose, so the "Are you sure..." dialog stayed
    // open after the delete dispatched (re-activating it errored). Close it
    // explicitly, mirroring the Cancel button's planDeletePopover.close().
    this.planDeletePopover?.close();
    this.deletePlans(this.selectedPlans);
  }

  focusDeleteDialog() {
    // a11y (WCAG 2.4.3 Focus Order, ARIA dialog pattern): move focus to the
    // first interactive control (Cancel) when the delete popover opens.
    setTimeout(() => {
      // a11y: ng-bootstrap gives the popover wrapper role="tooltip", whose text
      // content (the confirmation prompt) is exposed as its accessible name.
      // Combined with the nested role="dialog" labelled by that same prompt,
      // JAWS announced the message twice. Strip the redundant tooltip semantics
      // so only the inner dialog announces the prompt once. Only neutralize when
      // ng-bootstrap actually applied role="tooltip", so future markup changes
      // are not silently clobbered.
      const popoverWindow = this.document.querySelector<HTMLElement>("ngb-popover-window");
      if (popoverWindow?.getAttribute("role") === "tooltip") {
        popoverWindow.setAttribute("role", "presentation");
      }
      const firstBtn = this.document.querySelector<HTMLElement>('ngb-popover-window [role="dialog"] button');
      if (firstBtn) {
        firstBtn.focus();
        return;
      }
      this.document.querySelector<HTMLElement>('ngb-popover-window [role="dialog"]')?.focus();
    });
  }

  // a11y (focus trap): cycle Tab / Shift+Tab between Cancel and Confirm so
  // focus cannot escape the open delete popover.
  onPlanDeleteDialogTab(event: KeyboardEvent): void {
    const dialog = this.document.querySelector<HTMLElement>('ngb-popover-window [role="dialog"]');
    const buttons = Array.from(this.document.querySelectorAll<HTMLElement>('ngb-popover-window [role="dialog"] button'));
    if (!dialog || buttons.length < 2) return;
    const first = buttons[0];
    const last = buttons[buttons.length - 1];
    const active = this.document.activeElement;
    const shift = event.shiftKey;
    if (!shift && active === last) {
      event.preventDefault();
      first.focus();
    } else if (shift && active === first) {
      event.preventDefault();
      last.focus();
    }
  }

  returnFocusToPlanDeleteBtn(): void {
    // a11y: return focus to the Delete button when the popover closes.
    setTimeout(() => {
      this.document.querySelector<HTMLElement>('#btn-delete button')?.focus();
    });
  }

  deleteSinglePlan(plan: any){
    let plans = [plan];
    this.deletePlans(plans);
  }

  deletePlans(plans: any) {
    const planIds = plans.map((p: any) => p.planId);
    this.startLoadingGrid();
    this.store.dispatch(new DeletePlans(planIds));
  }

  showCreatePlanDlg() {
    const modalRef = this.modalService.open(CreatePlanComponent, {
      centered: true,
      windowClass: "b-info wfm-modal create-plan",
      container: "div.manage-plan-content",
      backdrop: "static",
      keyboard: false
    }).result.then((data) => {
      this.planCreatedAction(data);
    }, (reason) => {

    });
  }
  async showMswfRulesDlg(row) {
    const modalRef = this.modalService.open(MswfRulesDialogComponent, {
      centered: true,
      windowClass: "b-info wfm-modal mswf-rules",
      container: "div.manage-plan-content",
      backdrop: "static",
      keyboard: false
    });
    modalRef.componentInstance.mswfData = row.multiStepWorkflow;
    modalRef.componentInstance.planName = row.planName;

    await modalRef.result;
  }

  showCreateSitePlanDlg() {
    const modalRef = this.modalService.open(CreatePlanComponentV2, {
      centered: true,
      windowClass: "b-info wfm-modal create-plan",
      container: "div.manage-plan-content",
      backdrop: "static",
      keyboard: false,
      ariaLabelledBy: "dialogTitle"
    });
    this.inertModalBackground(modalRef);
    modalRef.result.then((data) => {
      this.startLoadingGrid();
      // this.planCreatedAction(data);
    }, (reason) => {

    });
  }

  /**
   * Fully hide ng-bootstrap's modal background from assistive technology while a
   * modal is open. ng-bootstrap marks the page behind the modal with
   * `aria-hidden="true"`, but those containers still hold focusable children
   * (flagged as "aria-hidden on parent of focusable"), and scanners that don't
   * recognise `inert` still report "content behind modal is still accessible".
   *
   * Setting `inert` on the background containers resolves both: an inert subtree
   * is removed from the accessibility tree entirely and all interaction is
   * blocked (WCAG 1.3.2, 4.1.2), without affecting visual rendering — so the
   * grid stays visible behind the backdrop. We also strip ng-bootstrap's
   * now-redundant `aria-hidden` so it can never be flagged as wrapping a
   * focusable element. The `inert` attribute is removed when the modal closes.
   */
  private inertModalBackground(modalRef: NgbModalRef): void {
    setTimeout(() => {
      const inerted: HTMLElement[] = [];
      this.document
        .querySelectorAll<HTMLElement>('[aria-hidden="true"]')
        .forEach((el) => {
          // Skip the modal itself / its ancestors and the backdrop.
          if (el.querySelector("ngb-modal-window") || el.closest("ngb-modal-window")) return;
          if (el.classList.contains("modal-backdrop")) return;
          // Only inert containers that actually hold focusable content.
          if (!el.querySelector('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])')) return;
          inerted.push(el);
          el.setAttribute("inert", "");
          el.removeAttribute("aria-hidden");
        });
      modalRef.result.finally(() =>
        inerted.forEach((el) => el.removeAttribute("inert"))
      );
    });
  }

  createPlanSuccessHandler() {
    this.planCreateSuccess = true;
    this.searchBoxEl.clear();
    this.filterText = "";
    const currSortState = this.gridColumnApi.getColumnState().find(col => col.sort !== null);
    if (currSortState && currSortState.colId === "modifiedDate" && currSortState.sort === "desc") {
      this.startLoadingGrid();
      const startRow = this.currentGetRowParam.startRow;
      const blockSize = this.currentGetRowParam.endRow - startRow;
      let payload = { offset: startRow, limit: blockSize, "sort-by": ColumnId.modifiedDate, "sort-order": "DESC", "plan-name-filter": this.filterText };
      this.store.dispatch(new GetPlanList(payload));

    } else {
      const colIdArr = this.gridColumnApi.getColumns().map(col => col.colId);
      EspTableHeaderComponent.clearSortOrder();
      let sortModel = EspTableHeaderComponent.getSingleColumnSortModel("modifiedDate", "desc", colIdArr);
      this.gridColumnApi.applyColumnState({ state: sortModel });
    }
    this.gridApi.ensureIndexVisible(0, "top");
  };

  setColumnDefsSort(colId: ColumnId, sortOrder: String) {
    if (!colId || !sortOrder) {
      // default is plan name ascending
      this.columnDefs[1]["sort"] = "asc";
    } else {
      switch (colId) {
        case ColumnId.modifiedDate:
          this.columnDefs[4]["sort"] = sortOrder;
          break;
        default:
          // plan name ascending is default
          this.columnDefs[1]["sort"] = "asc";
      }
    }
  }

  createPlanErrorHandler(resp: any) {
    console.log("ERROR:", resp);
    this.endLoadingGrid();
    if (resp.status === 401 || resp.status === 500) {
      this.unrecoverableErrorHandler(resp);
    } else {
      let failMsg = this.translate.instant("plan.create.failure");
      this.messageService.add({ severity: "error", detail: failMsg });
    }
  }

  planCreatedAction(obj: Observable<any>) {
    this.startLoadingGrid();
    obj.subscribe(this.createPlanSuccessHandler.bind(this), this.createPlanErrorHandler.bind(this));
  }

  // a11y: when focus lands on the select column gridcell, forward focus to
  // the native checkbox so screen readers announce role/state immediately.
  onCellFocused(event: any) {
    if (!event || event.rowIndex == null || event.column?.getColId?.() !== "select") return;
    setTimeout(() => {
      const rowSelector = `.ag-row[row-index="${event.rowIndex}"]`;
      const checkbox = this.document.querySelector<HTMLInputElement>(
        `${rowSelector} .ag-cell[col-id="select"] input[type="checkbox"]`
      );
      if (checkbox && this.document.activeElement !== checkbox) {
        checkbox.focus();
      }
    });
  }

  // a11y (ESP-18522): keyboard parity with mouse — pressing Enter on ANY data
  // cell performs the same row-level open action as a click. Arrow keys move
  // between cells (AG Grid native); Tab visits the interactive controls only.
  onCellKeyDown(event: any) {
    const kbEvent: KeyboardEvent | undefined = event?.event;
    if (!kbEvent) return;
    if (kbEvent.key === "Enter") {
      this.performCellClick(event);
      return;
    }
    if (kbEvent.key === "Tab") {
      this.moveTabFocusToNextControl(kbEvent);
    }
  }

  // a11y (ESP-18522): drive Tab focus explicitly between the interactive row
  // controls so the Tab order matches the accessibility review exactly:
  //   sortable headers → row checkbox → Plan Name → optional row actions →
  //   Delete → next row.
  // Relying on AG Grid's native Tab is unreliable — its tab guards re-focus the
  // originating cell, so Tab appears "stuck" on the checkbox — hence we move
  // focus ourselves. Shift+Tab walks the same list in reverse; at the first /
  // last control we let focus leave the body naturally. At the first control,
  // Shift+Tab explicitly returns to Actions; the browser would
  // otherwise land on AG Grid's focusable rowgroup container.
  private moveTabFocusToNextControl(kbEvent: KeyboardEvent) {
    const controls = this.getRowInteractiveControls();
    const active = this.document.activeElement as HTMLElement | null;
    if (!active) return;
    const index = controls.indexOf(active);
    if (index === -1) return;
    const nextIndex = kbEvent.shiftKey ? index - 1 : index + 1;
    if (nextIndex < 0) {
      if (kbEvent.shiftKey && this.focusLastHeaderTarget()) {
        kbEvent.preventDefault();
      }
      return;
    }
    if (nextIndex >= controls.length) return;
    kbEvent.preventDefault();
    const next = controls[nextIndex];
    // Keep AG Grid's internal focused cell in sync with our manual focus move,
    // otherwise the previously focused cell keeps its .ag-cell-focus outline
    // (e.g. the first row checkbox stays "focused" after tabbing away).
    this.syncFocusedCell(next);
    next.focus();
  }

  /**
    * Continue forward Tab traversal from the Actions header into the first
    * rendered interactive body control.
   */
  public focusFirstGridBodyControl(): boolean {
    const first = this.getRowInteractiveControls()[0];
    if (!first) return false;
    this.syncFocusedCell(first);
    first.focus();
    return true;
  }

  /** Reverse counterpart of focusFirstGridBodyControl(). */
  private focusLastHeaderTarget(): boolean {
    const hostEl = this.elementRef.nativeElement as HTMLElement;
    const headers = Array.from(
      hostEl.querySelectorAll<HTMLElement>(
        ".ag-header-cell:has(button.customHeaderLabel), " +
        ".ag-header-cell.esp-static-header-tab-stop"
      )
    ).filter((header) => header.offsetParent !== null);
    const last = headers[headers.length - 1];
    if (!last) return false;

    // The destination is a header, so clear AG Grid's body-focused-cell model
    // before moving real DOM focus; otherwise the first checkbox cell keeps a
    // stale second focus indicator while Actions is focused.
    this.gridApi?.clearFocusedCell?.();
    last.focus();
    return true;
  }

  // Move AG Grid's focused-cell highlight onto the cell that owns the control we
  // just focused, so the stale outline on the previous cell is cleared.
  private syncFocusedCell(control: HTMLElement) {
    if (!this.gridApi) return;
    const cell = control.closest<HTMLElement>(".ag-cell");
    const row = control.closest<HTMLElement>(".ag-row");
    const colId = cell?.getAttribute("col-id");
    const rowIndex = row?.getAttribute("row-index");
    if (colId == null || rowIndex == null) return;
    this.gridApi.setFocusedCell(parseInt(rowIndex, 10), colId);
  }

  // Interactive controls in the grid body, in visual row/column order. Query
  // real controls rather than hard-coding only checkbox / Plan Name / Delete,
  // so an optional in-cell action such as the MSWF button is not skipped.
  // Disabled / hidden controls (e.g. Plan Name is a plain <span> for inactive
  // plans) are omitted. The Delete button deliberately has tabindex="-1"
  // because its owning cell activates it, but it remains an explicit stop in
  // this managed in-grid order.
  private getRowInteractiveControls(): HTMLElement[] {
    const rows = Array.from(
      this.document.querySelectorAll<HTMLElement>(".ag-center-cols-container .ag-row")
    ).sort(
      (a, b) =>
        parseInt(a.getAttribute("row-index") ?? "0", 10) -
        parseInt(b.getAttribute("row-index") ?? "0", 10)
    );
    const controls: HTMLElement[] = [];
    rows.forEach((row) => {
      const rowControls = Array.from(
        row.querySelectorAll<HTMLElement>(
          ".ag-cell button, .ag-cell a[href], .ag-cell input, " +
          ".ag-cell select, .ag-cell textarea, .ag-cell [role=\"button\"]"
        )
      );
      rowControls.forEach((el) => {
        if (!el.hasAttribute("disabled") &&
            el.getAttribute("aria-disabled") !== "true" &&
            el.offsetParent !== null &&
            !controls.includes(el)) {
          controls.push(el);
        }
      });
    });
    return controls;
  }

  performCellClick(event) {
    if (ColumnId[event.colDef.colId] && event.data && event.data.status.toLowerCase() === "active") {
      // let isCXOneWfm = this.authService.userData.idpType === "CXONE_WFM";
      let sitePlansVersion = "site-plans-v5";
      let urlRoot = event.data.planGeneration == PlanGen.V2  ?  sitePlansVersion : "plans";
      this.router.navigate([{ outlets: { primary: [urlRoot, event.data.planId] } }]);
    }
  }

  get selectedPlans() {
    if (this.gridApi !== null) {
      return this.gridApi.getSelectedNodes().map(item => item.data);
    }
    return null;
  }

  get selectedPlanCount() {
    if (this.gridApi !== null) {
      const selectedNodes = this.gridApi.getSelectedNodes();
      return selectedNodes && selectedNodes !== null && selectedNodes.length > 0 ? selectedNodes.length : 0;
    }
    return 0;
  }

  get hasSelectedPlan() {
    return this.selectedPlanCount > 0;
  }

  get hasEspModifyPermission() {
    return this.espPermission === EspPermission.MODIFY;
  }


  disableRows(params: any) {
    if (params && params.data) {
      return params.data.status.toLowerCase() !== "active";
    }
    else return false;
  }

  isRowViewOnly(params) {
    if (params && params.data && params.data.permission && !this.disableRows(params)) {
      return params.data.permission.toLowerCase() === "view";
    }
    return false;
  }

  private prevData: any = { plans: [], lastRow: 0 };

  planListReceiveHandler(action: PlanListReceived) {
    if(action.requestPayload && action.requestPayload["plan-name-filter"]!= this.filterText){
      return;
    }

    let data = action.payload;
    var lastRow = -1;
    if (data.totalCount <= this.currentGetRowParam.endRow) {
      lastRow = data.totalCount;
    }
    // Checks the data and make sure that the return is an array for the grid to process properly
    let plans = !data.plans || data.plans === null ? [] : data.plans;
    if (data.offset == 0) { //it's the first page
      this.prevData = { plans, lastRow };
      // Announce search results count to screen readers using the backend total
      // (gridApi.getDisplayedRowCount() is unreliable for the infinite row model).
      this.updateSearchAnnouncement(data.totalCount ?? 0);
    } else {
      this.prevData = { plans: [...this.prevData.plans, ...plans], lastRow }; //append to previous plans
    }

    this.currentGetRowParam.successCallback(plans, lastRow);
    this.endLoadingGrid();
    // In case we have no plan, we want to show no row overlay
    if (Array.isArray(plans) && plans.length === 0) {
      this.gridApi.showNoRowsOverlay();
    }

    /*Show toast if GetPlanList triggered by create plan*/
    if (this.planCreateSuccess) {
      this.planCreateSuccess = false;
      let successMsg = this.translate.instant("plan.create.success");
      this.messageService.add({ severity: "success", detail: successMsg });
    }
  }

  planListRetrieveFailHandler(action: PlanListRetrieveFailed) {
    console.log("ERROR retrieving plan list");
    if (this.prevData.plans.length > 0) {
      let plans = this.prevData.plans.slice(0, 100); //100 is the block size
      this.currentGetRowParam.successCallback(plans, plans.length);
    } else {
      this.currentGetRowParam.successCallback([], 0);
    }
    this.endLoadingGrid();
    let failMsg = this.translate.instant("plan.retrieve.failed");
    this.messageService.add({ severity: "error", detail: failMsg });
  }

  deletePlansSuccessHandler(action: DeletePlansSuccess) {
    if (action.payload) {
      let deletedPlansResp = action.payload.deletedPlans;
      let succeeded: Array<string> = deletedPlansResp.SUCCESS;
      let failed = deletedPlansResp.FAILED;
      let sortModel = this.currentGetRowParam.sortModel;
      if(sortModel.length == 0)
        sortModel = this.DEFAULT_SORT_MODEL;
      this.gridColumnApi.applyColumnState({state:sortModel});
      // this.gridApi.deselectAll();
      // this.gridApi.refreshInfiniteCache();
      this.gridApi.ensureIndexVisible(0, "top");
      this.gridApi.setDatasource(this.datasource);
      if ((failed == null || failed.length == 0) && succeeded.length > 0) {
        let plansDeleted = (succeeded.length == 1) ? "single" : "multiple";
        let successMsg = this.translate.instant("plan.delete.success." + plansDeleted);
        this.messageService.add({ severity: "success", detail: successMsg });
      }
      else if (failed.length > 0) {
        let failMsg = this.translate.instant("plan.delete.failed");
        this.messageService.add({ severity: "error", detail: failMsg });
      }
    }
    this.endLoadingGrid();

  }

  deletePlansFailureHandler(action: DeletePlansFailed){
    const failMsg = this.translate.instant("plan.retrieve.failed");
    this.messageService.add({ severity: "error", detail: failMsg });
    this.endLoadingGrid();
  }

  ltfRetrieveFailHandler(){
    const logout = () => {
      if(this.router.navigate(["/login"]))
        this.authService.logout();
    };
    const dialogOpt:DialogOptions = new DialogOptions();
    dialogOpt.titleKey = "generic.err.title";
    dialogOpt.messageKey = "generic.err.msg";
    dialogOpt.msgType = "error";
    dialogOpt.confirmLabel = "btn.signin";
    dialogOpt.showCancel = false;
    modalComponent.showModalMessage(dialogOpt, this.modalService).then(logout, logout);
  }

  unrecoverableErrorHandler(error:any) {
    this.modalService.dismissAll();
    const done = ()=>{};
    const dialogOpt:DialogOptions = new DialogOptions();
    dialogOpt.titleKey = "generic.err.title";
    dialogOpt.messageKey = "unrecoverable.err.msg";
    dialogOpt.msgType = "error";
    dialogOpt.confirmLabel = "btn.close";
    dialogOpt.showCancel = false;
    modalComponent.showModalMessage(dialogOpt, this.modalService).then(done, done);
  }

  startLoadingGrid(){
    this.gridApi.showLoadingOverlay();
    this._isLoading = true;
  }

  endLoadingGrid(){
    this.gridApi.hideOverlay();
    this._isLoading = false;
  }

  setDefaultSorting(param:any){
    EspTableHeaderComponent.setSortOrder("planName", "asc");
  }

  // a11y: Use a dynamic, localized action+identifier label so screen readers
  // announce which row this native checkbox controls (e.g., "Select John Smith record").
  private applyCheckboxName(checkbox: HTMLInputElement, rowName: string) {
    const selectLabel = this.translate.instant("table.checkbox.select", { name: rowName });
    checkbox.setAttribute("aria-label", selectLabel);
    checkbox.removeAttribute("aria-labelledby");
    checkbox.removeAttribute("aria-describedby");
    checkbox.removeAttribute("title");
    // a11y (ESP-18522): the row checkbox is an interactive control and must be a
    // Tab stop. AG Grid ships the native checkbox at tabindex="-1", so promote it
    // to tabindex="0" for the managed Tab order (headers → checkbox → Plan
    // Name → optional row actions → Delete).
    checkbox.setAttribute("tabindex", "0");

    const checkboxWrappers = [
      checkbox.closest(".ag-selection-checkbox"),
      checkbox.closest(".ag-wrapper")
    ];

    checkboxWrappers.forEach((wrapper) => {
      if (!(wrapper instanceof HTMLElement)) return;
      wrapper.removeAttribute("aria-label");
      wrapper.removeAttribute("aria-labelledby");
      wrapper.removeAttribute("aria-describedby");
      wrapper.removeAttribute("title");
    });
  }

  applyCheckboxAriaLabels() {
    if (this.checkboxAriaLabelsScheduled) return;
    this.checkboxAriaLabelsScheduled = true;

    setTimeout(() => {
      this.checkboxAriaLabelsScheduled = false;
      const rows = this.document.querySelectorAll('.ag-row');
      rows.forEach((row: Element) => {
        const rowIndex = row.getAttribute('row-index');
        if (rowIndex === null) return;
        const rowNode = this.gridApi?.getDisplayedRowAtIndex(parseInt(rowIndex, 10));
        const planName = rowNode?.data?.planName;
        if (!planName) return;
        const checkbox = row.querySelector(
          '.ag-cell[col-id="select"] input[type="checkbox"], .ag-cell[col-id="0"] input[type="checkbox"], input[type="checkbox"].ag-checkbox-input'
        ) as HTMLInputElement;
        if (checkbox) {
          this.applyCheckboxName(checkbox, planName);
        }
      });
    }, 0);
  }


  initHandlers() {
    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.SortingCleared))
        .subscribe(this.setDefaultSorting.bind(this))
    );
    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.UnrecoverableError))
        .subscribe(this.unrecoverableErrorHandler.bind(this))
    );
    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.PlanListReceived))
        .subscribe(this.planListReceiveHandler.bind(this))
    );
    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.PlanListRetrieveFailed))
        .subscribe(this.planListRetrieveFailHandler.bind(this))
    );

    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.DeletePlansSuccess))
        .subscribe(this.deletePlansSuccessHandler.bind(this))
    );

    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.DeletePlansFailed))
        .subscribe(this.deletePlansFailureHandler.bind(this))
    );

    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.LTFRetrieveFail))
      .subscribe(this.ltfRetrieveFailHandler.bind(this))
    );

    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.CreatePlanSubmitted))
      .subscribe(this.createPlanSuccessHandler.bind(this))
    );

    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.CreatePlanError))
      .subscribe(this.createPlanErrorHandler.bind(this))
    );

    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.CreateCXonePlanSuccess))
      .subscribe(this.createPlanSuccessHandler.bind(this))
    );

    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.CreateCXonePlanFailed))
      .subscribe(this.createPlanErrorHandler.bind(this))
    );
  }

  protected addToSubscriptionList(newSubscription: Subscription) {
    this.subscriptionList.push(newSubscription);
  }

  private clearSubscriptionList() {
    if (this.subscriptionList.length > 0) {
      this.subscriptionList.forEach(subscriptionItem => subscriptionItem.unsubscribe());
      this.subscriptionList = null;
    }
  }

  public ngOnDestroy() {
    this.scrollRegionSyncCleanup?.();
    this.scrollRegionSyncCleanup = null;
    this.clearSubscriptionList();
  }

  checkBoxCellClass = (p:any) => {
    if(this.hasEspModifyPermission)
      return (p.data && p.data.permission === EspPermission.VIEW) ?  'checkbox-disabled': '';
    else
      return 'checkbox-hidden';
  }

  icons = {
    checkboxDisabled: `<svg class="icon"><use xlink:href="#icon-rect-disabled" /></svg>`,
    checkboxCheckedReadOnly: `<svg class="icon"><use xlink:href="#icon-rect-readonly" /></svg>`,
    sortAscending: `<svg class="icon"><use xlink:href="#icon-sort-ascending" /></svg>`,
    sortDescending: '<svg class="icon"><use xlink:href="#icon-sort-descending" /></svg>'
  };
  defaultColDef={
    sortable:true,
    // a11y (ESP-18522): the grid contains interactive controls (row checkbox,
    // Plan Name link, Delete icon), so Tab must visit each of those controls in
    // order (all sortable headers → row checkbox → Plan Name → optional row
    // actions → Delete) while read-only text cells are reachable only with the
    // Arrow keys. Home/End stay row/grid-scoped.
    suppressKeyboardEvent: combineGridKeyboardSuppressors(suppressGridTabToInteractiveControls, suppressHomeEndKeyboardEvent)
  }
  columnDefs:any = [

    {
      // Row selection column. Header text is visually hidden via the existing
      // .screenreader-only class but exposed to screen readers, so the column
      // has a programmatic accessible name (a11y).
      headerName: this.translate.instant("table.header.select"),
      colId: "select",
      field: null,
      sortable: false,
      headerClass: "screenreader-only",
      checkboxSelection: () => this.hasEspModifyPermission,
      cellClass: this.checkBoxCellClass.bind(this),
      headerCheckboxSelection: false,
      suppressSizeToFit: true,
      width: 50,
      headerTooltip: " "
    },
    {
      headerName: this.translate.instant("plan.header.planName"),
      field: "planName",
      colId: "planName",
      //autoHeight: true,
      cellRenderer: "TooltipField",
      // a11y (ESP-18464 / Dragon): expose the plan name as a voice-clickable
      // button when the plan is openable (active).
      cellRendererParams: {
        rowOpenAction: true,
        canOpen: (data: any) => !!data && data.status?.toLowerCase() === "active"
      },
      minWidth:150,
      cellClass(params) {
        if(params.data && params.data.permission && params.data.status.toLowerCase() === "active") {
          if (params.data.permission.toLowerCase() === "view") {
            return "cell-view-only-name";
          }
        }
        return "";
      }
    },
    {
      headerName: this.translate.instant("plan.header.createdBy"),
      field: "createdBy",
      colId: "createdBy",
      //autoHeight: true,
      cellRenderer: "TooltipField",
      minWidth: 100
    },
    {
      headerName: this.translate.instant("plan.header.dateRange"),
      colId: "dateRange",
      cellRenderer: "DateRangeField",
      cellRendererParams: () => (environment.locales.find(l => l.locale === this.locale)),
      suppressSizeToFit: true,
      width: 200
      //autoHeight: true
    },
    {
      headerName: this.translate.instant("plan.header.modifiedDate"),
      field: "modifiedTime",
      colId: "modifiedDate",
      cellRenderer: "ModifiedDateField",
      cellRendererParams: () => (environment.locales.find(l => l.locale === this.locale)),
      minWidth:100
    },
    {
      headerName: this.translate.instant("plan.header.entityType"),
      field: "entityType",
      colId: "entityType",
      cellRenderer: "EntityTypeField",
      // The MSWF icon is a real tabindex="0" <button> reached by native Tab
      // (like Plan Name / Forecast Name), so this column inherits defaultColDef's
      // suppressKeyboardEvent. It must NOT use the cell-stop
      // tabSuppressKeyboardEventForFocusableChildren pattern (that is for
      // tabindex="-1" children such as the Delete icon), which would drop the
      // button out of the Tab order.
      minWidth:100
    },
    {
      headerName: this.translate.instant("plan.header.entity"),
      field: "entityName",
      colId: "entity",
      cellRenderer: "EntityField",
      minWidth:150
    },
    {
      headerName: this.translate.instant("plan.header.forecastName"),
      field: "ltfcstName",
      colId: "forecastName",
      //autoHeight: true,
      cellRenderer: "TooltipField",
      minWidth:150
    },
    {
      headerName: this.translate.instant("plan.header.actions"),
      colId: "actions",
      sortable: false,
      headerClass: "text-center only-action",
      suppressSizeToFit: true,
      width: 100,
      //pinned: "right",
      suppressKeyboardEvent: combineGridKeyboardSuppressors(suppressGridTabToInteractiveControls, suppressHomeEndKeyboardEvent, tabSuppressKeyboardEventForFocusableChildren),
      cellRendererSelector: (p:any)=>(p.data && p.data.permission === EspPermission.VIEW)
      ? null :
      {
        component: 'GridItemActionComponent',
        params: {
          callback: this.deleteSinglePlan.bind(this),
          messageDelete: this.translate.instant("plan.delete.single"),
          itemNameField: "planName"
        }
      }
    }
  ];

  showCreateCxonePlanDlg() {
    const modalRef = this.modalService.open(CreatePlanCXoneComponent, {
      centered: true,
      windowClass: "b-info wfm-modal create-plan",
      container: "div.manage-plan-content",
      backdrop: "static",
      keyboard: false
    }).result.then((data) => {
      this.startLoadingGrid();
    }, (reason) => {
      console.debug("dismissed CXone create plan dialog");
    });
  }

  showIexOrCxonePlanDlg() {
    if (this.tenantService.isCXOne) {
      this.showCreateCxonePlanDlg();
    } else {
      this.showCreateSitePlanDlg();
    }
  }

  adjustColumnWidths() {
    const columnState = [
      { colId: 'planName', minWidth: 250 },
      { colId: 'createdBy', minWidth: 200 },
      { colId: 'dateRange', width: 250 },
      { colId: 'modifiedDate', minWidth: 150 },
      { colId: 'forecastName', minWidth: 250 }
    ];
    this.gridColumnApi.applyColumnState({ state: columnState});
    this.gridApi.sizeColumnsToFit();
  }
}

export enum ColumnId {
  planName = "PLAN_NAME",
  createdBy = "CREATED_BY",
  modifiedDate = "MODIFIED_DATE",
  entityType = "ENTITY_TYPE",
  entity = "ENTITY",
  forecastName = "FORECAST_NAME",
  dateRange = "DATE_RANGE"
}

export enum EspPermission {
  MODIFY = "MODIFY",
  VIEW = "VIEW"
}



